import { Placeholder } from "../../../../../../components/Placeholder/Placeholder"

export const LoaderForm = () => {
    return (
        <>
            <div className="col-12 mb-4">
                <Placeholder className='py-2' height='2rem' />
            </div>
            <div className="col-12 mb-4">
                <Placeholder className='py-2' height='2rem' />
            </div>
            <div className="col-12 col-sm-6 col-lg-5 col-xl-4 mb-4">
                <Placeholder className='py-2' height='2rem' />
            </div>
            <div className="col-12 col-sm-6 col-lg-5 col-xl-4 mb-4">
                <Placeholder className='py-2' height='2rem' />
            </div>
            <div className="col-12 col-sm-12 col-lg-12 col-xl-10 mb-4">
                <Placeholder className='py-2' height='2rem' />
            </div>
            <div className="col-xl-8 mb-4">
                <Placeholder className='py-2' height='8rem' />
            </div>
            <div className="col-xl-4 mb-4">
                <Placeholder className='py-2' height='4rem' />
            </div>
        </>
    )
}
